
const CardsContent = ({data}) => {

    return (
        <>
            <div className="grid grid-cols-3 gap-2">
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Total de ocorrências</h3><h2>{data.total_occ ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Média diária de ocorrências</h3><h2>{data.daily_avg ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-3">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Ocorrências concluídas (%)</h3><h2>{data.percent_concluded ?? 0}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-2 justify-content-center align-items-center">
                <div className="mb-1 mt-1">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Ocorrências com veículos</h3><h2>{data.vehicles_occ ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-1">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Total de veículos envolvidos</h3><h2>{data.vehicles_qty ?? 0}</h2>
                        </div>
                    </div>
                </div>
                <div className="mb-1 mt-1">
                    <div className="text-center">
                        <div className="box boxCount cursor-pointer" title="Apenas ocorrências concluídas e ativas.">
                            <h3>Total de indivíduos envolvidos</h3><h2>{data.ind_qty ?? 0}</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="chart-divisor"></div>
        </>
    );
};

export default CardsContent;